import type { LookConfig } from '../types/look-config'

export const mockLookConfig: LookConfig = {
  id: 'mock-look-1',
  title: 'Подбор образа',
  steps: [
    {
      id: 'welcome-1',
      type: 'welcome',
      title: 'Давайте подберем идеальный образ',
      subtitle: 'Ответьте на несколько вопросов, чтобы мы могли создать образ, который вам понравится.'
    },
    {
      id: 'occasion-1',
      type: 'occasion',
      title: 'Для какого события?',
      subtitle: 'Выберите событие, для которого нужен образ',
      required: true,
      occasions: [
        { value: 'work', label: 'Работа' },
        { value: 'date', label: 'Свидание' },
        { value: 'party', label: 'Праздник' },
        { value: 'casual', label: 'Повседневный' },
        { value: 'sport', label: 'Спорт' }
      ]
    },
    {
      id: 'form-1',
      type: 'dynamic_form',
      title: 'Уточните детали',
      subtitle: 'Помогите нам лучше понять ваши предпочтения',
      required: false,
      fields: [
        {
          id: 'gender',
          label: 'Пол',
          type: 'select',
          required: true,
          options: [
            { value: 'male', label: 'Мужской' },
            { value: 'female', label: 'Женский' }
          ]
        },
        {
          id: 'age',
          label: 'Возраст',
          type: 'input',
          placeholder: 'Введите возраст',
          required: true
        },
        {
          id: 'size',
          label: 'Размер одежды',
          type: 'select',
          required: false,
          options: [
            { value: 'xs', label: 'XS' },
            { value: 's', label: 'S' },
            { value: 'm', label: 'M' },
            { value: 'l', label: 'L' },
            { value: 'xl', label: 'XL' }
          ]
        }
      ]
    },
    {
      id: 'tinder-1',
      type: 'tinder_like',
      title: 'Как вам этот образ?',
      subtitle: 'Смахните вправо, если образ вам нравится, и влево — если нет',
      required: false,
      autoNext: true,
      cardsCount: 10
    },
    {
      id: 'completion-1',
      type: 'completion',
      title: 'Образ готов!',
      subtitle: 'Мы подобрали идеальный образ специально для вас'
    }
  ]
}

